export default {
	// 订单预览
	OrderPreview: '/ShopOrder/OrderPreview',
	// 创建订单
	CreateOrder: '/ShopOrder/CreateOrder',
	// 用户订单列表
	GetUserOrderList: '/ShopOrder/GetUserOrderList',
	// 取消订单
	CancelOrder: '/ShopOrder/CancelOrder',
	// 收货人信息修改
	UpdateOrderReceiverInfo: '/ShopOrder/UpdateOrderReceiverInfo',
	// 商品列表
	ProductList: '/Product/ProductList',
	// 商品详情
	ProductInfo: '/Product/ProductInfo',
	// 商品详情其他用户信息
	ProductPageOtherInfo: '/Product/ProductPageOtherInfo',
};



// WEBPACK FOOTER //
// ./src/service/api/modules/mall.js